import { FC, useState } from "react"
import { useParams } from "react-router-dom"

import PricingProfilesTable from "../../common/ui/pricing-profiles/table"
import {
  If,
  LoanProgramDetailsHeader,
  PricingProfileDetails
} from "../../common/ui"
import { useFetchPricingSetDetailsQuery } from "../../redux/queries"
import { RequireRole } from "../../common/validation"
import { ALLOWED_ROLES_BY_ROUTE } from "../../common/constants"
import { PricingProfile } from "../../types"

const LoanProgramDetailsPage: FC = () => {
  const { id } = useParams()
  const [selectedItem, setSelectedItem] = useState<PricingProfile | undefined>(
    undefined
  )
  const { data: pricingSet, isLoading } = useFetchPricingSetDetailsQuery(
    {
      id: id ?? ""
    },
    { refetchOnMountOrArgChange: true }
  )

  const handleSelectItem = (id: string) => {
    const selectedPricingProfile = pricingSet?.pricing_profiles?.find(
      pp => pp.pricing_profile_id === id
    )
    setSelectedItem(selectedPricingProfile)
  }

  const handleClose = () => setSelectedItem(undefined)

  return (
    <RequireRole allowedRoles={ALLOWED_ROLES_BY_ROUTE["loan-programs"]}>
      <If
        isLoading={isLoading}
        condition={!!pricingSet}
        then={
          <>
            <div className="h-full flex flex-col">
              <div className="pt-6 bg-white">
                <div className="px-6">
                  <LoanProgramDetailsHeader pricingSet={pricingSet!} />
                </div>
              </div>
              <div className="p-6 flex-1 bg-white">
                <PricingProfilesTable
                  data={pricingSet?.pricing_profiles ?? []}
                  isLoading={isLoading}
                  hasAction
                  isFullCellClickable
                  onClickItem={handleSelectItem}
                />
              </div>
            </div>

            <PricingProfileDetails
              pricingProfile={selectedItem}
              onClose={handleClose}
            />
          </>
        }
        else={
          <div className="p-6">
            Could not fetch details of this loan program.
          </div>
        }
      />
    </RequireRole>
  )
}

export default LoanProgramDetailsPage
